import { applyLoginOrgLogo } from "../../admin-shared/applyLoginOrgLogo";
import { persistAdminScope } from "../../admin-shared/adminScopeStorage";

const PORTAL_HOME = {
  workspace: "/nyafaz-ep/workspace/overview",
  executive: "/nyafaz-ep/executive/overview",
  partner: "/nyafaz-ep/partner/overview",
};

export function homePathForPortal(portal) {
  const key = String(portal || "workspace").toLowerCase();
  return PORTAL_HOME[key] || PORTAL_HOME.workspace;
}

export async function persistPortalLoginSession(portal, data) {
  const p = String(portal || "workspace").toLowerCase();
  const prefix = `naturals_${p}_`;

  localStorage.removeItem(`${prefix}AUTH_TOKEN`);
  localStorage.setItem(`${prefix}userId`, data.userId);
  if (data.organizationId != null && data.organizationId !== "") {
    localStorage.setItem(`${prefix}orgId`, String(data.organizationId));
  } else {
    localStorage.removeItem(`${prefix}orgId`);
  }
  if (data.franchiseId != null && data.franchiseId !== "") {
    localStorage.setItem(`${prefix}franchiseId`, String(data.franchiseId));
  } else {
    localStorage.removeItem(`${prefix}franchiseId`);
  }
  const role = (
    data.role || (data.is_super_admin ? "super_admin" : data.is_admin ? "admin" : "user")
  ).toLowerCase();
  localStorage.setItem(`${prefix}accessModules`, JSON.stringify(data.allowed_modules || []));
  localStorage.setItem(`${prefix}role`, role);
  localStorage.setItem(`${prefix}plan`, (data.plan || "standard").toLowerCase());
  localStorage.setItem(`${prefix}plan_status`, (data.plan_status || "active").toLowerCase());
  if (data.admin_permissions) {
    localStorage.setItem(`${prefix}admin_permissions`, JSON.stringify(data.admin_permissions));
  }
  const storagePrefix = `naturals_${p}`;
  if (data.admin_scope || data.adminScope) {
    persistAdminScope(data.admin_scope || data.adminScope, storagePrefix);
  } else if (role === "admin") {
    persistAdminScope("regions", storagePrefix);
  }
  const mediaUrl = await import("./mediaUrl");
  applyLoginOrgLogo(mediaUrl.persistOrgLogo, data.org_logo);
  localStorage.setItem(`${prefix}powered_by_nyafaz`, data.powered_by_nyafaz === false ? "0" : "1");
}
